import type { PortfolioCommandData } from '@festina/unitlink-general-types/unitlink'
import { PortfolioSourcesEventsService } from '@festina/unitlink-general-types/unitlink/services/PortfolioSourcesEventsService'
import { useFestinaMutation } from '@festina-life/authentication'

import type { PortfolioActionProps } from '../types'

const method = PortfolioSourcesEventsService.portfolioSourcesServicePutEvents

export const useEditPortfolioEvent = <T extends PortfolioCommandData>({
  ownerId,
  tenantId,
  commandId,
}: PortfolioActionProps) =>
  useFestinaMutation({
    component: 'unitLink',
    roles:
      PortfolioSourcesEventsService.portfolioSourcesServicePostEvents_roles,
    isScenario: false,
    mutateFunction: async (arg: T) => {
      await method({
        ownerId,
        xTenantId: tenantId,
        eventId: commandId ?? '',
        requestBody: {
          _type: 'CreatePortfolioCommand',
          commandData: arg,
        },
      })
    },
  })
